import { PermissionModel } from "@/features/admin";
import { TextValueModel } from "@/types/common";

export type UserDetailModel = {
  userId: number;
  firstName: string;
  lastName: string;
  name: string;
  email: string;
  mobile: string;
  distanceRadius: number;
  location: string;
  address?: string;
  profileImageUrl: string;
  roles: string[];
  maxAdvertCount?: number;
};

export type LoginResponse = {
  authToken: string;
  role: string;
  userDetail: UserDetailModel;
  distanceOptions: TextValueModel[];
  permissions: PermissionModel[];
};

export type AppDataModel = {
  googleAdUnitId: string;
  instagramClientId: string;
  instagramClientSecret: string;
  twitterClientId: string;
  twitterClientSecret: string;
  googleClientId: string;
  googleApiKey: string;
  fbAppId: string;
  languageList: TextValueModel[];
  merchantBusinessCategoryList: TextValueModel[];
};

export type TermsAndPrivacyResponse = {
  termsText: string;
  privacyPolicyText: string;
};

export enum ExternalLogin {
  Facebook = 1,
  Google = 2,
  Twitter = 3,
}

export type ExternalLoginRequestModel = {
  email?: string;
  firstName?: string;
  lastName?: string;
  provider: ExternalLogin;
  token?: string;
  refreshToken?: string;
  location?: string;
};
